module.exports = __webpack_public_path__ + "img/audi-header.1c6d02df.png";